import { keyframes } from 'styled-components';

export const spin = keyframes`
0%{ transform: rotate(0deg)}
100%{ transform: rotate(359deg)}`;

// inside
export const insideLoader1 = keyframes`
0%{ left: -20px; background-color: rgba(163, 163, 163, .8)}
50%{ left: 0px; background-color: rgba(163, 163, 163, .1)}
100%{ left:-20px; background-color: rgba(163, 163, 163, .8)}
`;

export const insideLoader2 = keyframes`
0%{ left: 20px; background-color: rgba(163, 163, 163, .8)}
50%{ left: 0px; background-color: rgba(163, 163, 163, .1)}
100%{ left:20px; background-color: rgba(163, 163, 163, .8)}
`;
